import { PropsWithChildren } from 'react';
import { Box } from '@bridebook/ui';
import componentStyles from './section-text.style';

interface IProps extends PropsWithChildren {
  as?: string;
  lineHeight?: number;
  clampTo?: number;
  fontSize?: number;
  noBlock?: boolean;
}

const SectionText = ({ as = 'div', children, lineHeight, clampTo, fontSize, noBlock }: IProps) => {
  const styles = componentStyles({ lineHeight, clampTo, fontSize, noBlock });

  return (
    <Box as={as} style={styles.wrapper}>
      {children}
    </Box>
  );
};

export default SectionText;
